var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h5 lighten-2" },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "xs12 sm12 layout flex-row wrap justify-space-between"
                    },
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c("h2", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("Reporte Solicitado")
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: " d-flex justify-center align-center",
                          staticStyle: { cursor: "pointer" },
                          on: { click: _vm.cerrarModal }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488E" } }, [
                            _vm._v("close")
                          ]),
                          _c("span", { staticClass: "text-uppercase" }, [
                            _vm._v("Cerrar")
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "xs12 sm12 layout justify-center align-center wrap pa-0"
                    },
                    [
                      _c("p", { staticStyle: { "margin-top": "40px" } }, [
                        _vm._v(_vm._s(_vm.texto))
                      ]),
                      _c(
                        "p",
                        { staticStyle: { "margin-top": "40px" } },
                        [
                          _vm._v(
                            "\n            Puede ver sus reportes en el menú\n            "
                          ),
                          _c(
                            "router-link",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px"
                              },
                              attrs: {
                                "active-class": "router-link-active",
                                to: "/conecta-reportes"
                              }
                            },
                            [_vm._v("\n              Informes\n            ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }